module.exports = __webpack_public_path__ + "img/jbi_navbar_img@2x.ea8afa6c.png";